import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { parse, stringify } from 'qs';
import { SortIcon } from 'components';

import './table-header.scss';

@withRouter
export class TableHeader extends React.PureComponent {
  static propTypes = {
    sort: PropTypes.string,
    history: PropTypes.object,
    config: PropTypes.object.isRequired,
    defaultSort: PropTypes.string,
  };

  static defaultProps = {
    sort: null,
    history: {},
  };

  sortClick = (clickedSort) => {
    const { history, defaultSort } = this.props;
    const { location = {} } = history;
    const { search = '', pathname } = location;
    const queries = parse(search.substr(1)) || {};

    if (
      queries.sort === clickedSort ||
      (!queries.sort && clickedSort === defaultSort)
    ) {
      queries.sort = `!${clickedSort}`;
    } else {
      queries.sort = clickedSort;
    }

    const queriesString = `?${decodeURI(stringify(queries))}`;
    history.push(`${pathname}${queriesString}`);
  };

  renderArrow = (configItem, sort) => {
    if (!configItem.let) {
      return null;
    }

    let iconClassName = '';

    if (sort) {
      switch (sort) {
        case configItem.name:
          iconClassName = 'th__icon _asc';
          break;
        case `!${configItem.name}`:
          iconClassName = 'th__icon _desc';
          break;
        default:
          iconClassName = 'th__icon';
      }
    } else {
      const { defaultSort } = this.props;

      switch (defaultSort) {
        case configItem.name:
          iconClassName = 'th__icon _asc';
          break;
        case `!${configItem.name}`:
          iconClassName = 'th__icon _desc';
          break;
        default:
          iconClassName = 'th__icon';
      }
    }

    return <SortIcon className={iconClassName} />;
  };

  renderTitles = () => {
    const { config = {}, history } = this.props;
    const { columnsConfig = [], thClassName } = config;
    const { location = {} } = history;
    const { search = '' } = location;
    const queries = parse(search.substr(1));

    const titleArr = [];
    const configLength = columnsConfig.length;
    for (let i = 0; i < configLength; i += 1) {
      const configItem = columnsConfig[i];
      titleArr.push(
        <th
          className={`th ${thClassName || ''}`}
          style={{ width: configItem.width || 'auto' }}
          key={configItem.name}
        >
          <span
            onClick={() => {
              if (!configItem.sortable) return;
              if (typeof config.customSortClick === 'function') {
                return config.customSortClick(configItem.name);
              }
              this.sortClick(configItem.name);
            }}
            className={configItem.sortable ? 'th__sortable' : ''}
          >
            <span className="th__title word-break">
              {configItem.title || ''}
            </span>
            {this.renderArrow(configItem, this.props.sort || queries.sort)}
          </span>
        </th>,
      );
    }
    return titleArr;
  };

  render() {
    return (
      <thead>
        <tr>{this.renderTitles()}</tr>
      </thead>
    );
  }
}
